import "./assets/style.css.mjs";
import r from "./components/index.mjs";
import t from "./node_modules/v-wave/dist/es/index.mjs";
import { default as i } from "./utils/arrayUtils.mjs";
import { default as d } from "./utils/groupByUtils.mjs";
import { default as m } from "./utils/genericUtils.mjs";
import { default as x } from "./utils/optionsUtils.mjs";
import { default as c } from "./utils/dateUtils.mjs";
import { badgeDirective as y } from "./directives/badge.mjs";
import { useForm as v } from "./composables/useForm/useForm.mjs";
import { AmberColor as T, BlueColor as k, CyanColor as D, EmeraldColor as M, FuchsiaColor as U, GrayColor as A, GreenColor as B, IndigoColor as F, IstColor as L, LimeColor as O, MonoColor as P, OrangeColor as h, PinkColor as w, PurpleColor as G, RedColor as H, RoseColor as R, SkyColor as V, SlateColor as z, StoneColor as E, TealColor as N, VioletColor as W, YellowColor as Y, ZincColor as Z, amberColors as j, blueColors as q, cyanColors as J, emeraldColors as K, fuchsiaColors as Q, getAllISTcolors as X, grayColors as _, greenColors as $, indigoColors as oo, istColors as ro, limeColors as to, monoColors as eo, orangeColors as lo, pinkColors as ao, purpleColors as so, redColors as fo, roseColors as Co, skyColors as io, slateColors as po, stoneColors as no, tealColors as mo, violetColors as uo, yellowColors as xo, zincColors as Io } from "./include/colorMixin.mjs";
import { default as go } from "./components/pill/IstPill.vapor.vue.mjs";
import { default as bo } from "./components/button/IstButton.vue.mjs";
import { default as So } from "./components/icon/IstIcon.vue.mjs";
import { default as ko } from "./components/main_navigation/IstMainNavigation.vue.mjs";
import { default as Mo } from "./components/main_app/IstMainApp.vue.mjs";
import { default as Ao } from "./components/main_content/IstMainContent.vue.mjs";
import { default as Fo } from "./components/main_header/IstMainHeader.vue.mjs";
import { default as Oo } from "./components/skeleton/IstSkeleton.vue.mjs";
import { default as ho } from "./components/tab/IstTab.vue.mjs";
import { default as Go } from "./components/tab/IstTabs.vue.mjs";
import { default as Ro } from "./components/spinner/IstSpinner.vue.mjs";
import { default as zo } from "./components/input/IstInput.vue.mjs";
import { default as No } from "./components/textarea/IstTextarea.vue.mjs";
import { default as Yo } from "./components/label/IstLabel.vue.mjs";
import { default as jo } from "./components/card/IstCard.vue.mjs";
import { default as Jo } from "./components/card/IstCardContent.vue.mjs";
import { default as Qo } from "./components/card/IstCardDescription.vue.mjs";
import { default as _o } from "./components/card/IstCardFooter.vue.mjs";
import { default as or } from "./components/card/IstCardHeader.vue.mjs";
import { default as tr } from "./components/badge/IstBadge.vue.mjs";
import { default as lr } from "./components/card/IstCardTitle.vue.mjs";
const s = (o) => {
  r.install(o), o.use(t, {
    color: "#91D1DF",
    dissolveDuration: 0.2,
    finalOpacity: 0.9,
    easing: "ease-in",
    duration: 0.2,
    initialOpacity: 0.9,
    directive: "ripple"
  });
};
export {
  T as AmberColor,
  k as BlueColor,
  D as CyanColor,
  M as EmeraldColor,
  U as FuchsiaColor,
  A as GrayColor,
  B as GreenColor,
  F as IndigoColor,
  tr as IstBadge,
  bo as IstButton,
  jo as IstCard,
  Jo as IstCardContent,
  Qo as IstCardDescription,
  _o as IstCardFooter,
  or as IstCardHeader,
  lr as IstCardTitle,
  L as IstColor,
  s as IstComponents,
  So as IstIcon,
  zo as IstInput,
  Yo as IstLabel,
  Mo as IstMainApp,
  Ao as IstMainContent,
  Fo as IstMainHeader,
  ko as IstMainNavigation,
  go as IstPill,
  Oo as IstSkeleton,
  Ro as IstSpinner,
  ho as IstTab,
  Go as IstTabs,
  No as IstTextarea,
  O as LimeColor,
  P as MonoColor,
  h as OrangeColor,
  w as PinkColor,
  G as PurpleColor,
  H as RedColor,
  R as RoseColor,
  V as SkyColor,
  z as SlateColor,
  E as StoneColor,
  N as TealColor,
  t as VWave,
  W as VioletColor,
  Y as YellowColor,
  Z as ZincColor,
  j as amberColors,
  i as arrayUtils,
  y as badgeDirective,
  q as blueColors,
  J as cyanColors,
  c as dateUtils,
  K as emeraldColors,
  Q as fuchsiaColors,
  m as genericUtils,
  X as getAllISTcolors,
  _ as grayColors,
  $ as greenColors,
  d as groupByUtils,
  oo as indigoColors,
  ro as istColors,
  to as limeColors,
  eo as monoColors,
  x as optionsUtils,
  lo as orangeColors,
  ao as pinkColors,
  so as purpleColors,
  fo as redColors,
  Co as roseColors,
  io as skyColors,
  po as slateColors,
  no as stoneColors,
  mo as tealColors,
  v as useForm,
  uo as violetColors,
  xo as yellowColors,
  Io as zincColors
};
